import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "../configs/AppConfig";

const ReportService = {};

ReportService.getAgeReport = function (params) {
  // let page = params
  // let offset = (page-1)*10
  return fetch({
    url: API_BASE_URL + "/v1/admin/get-participant-report",
    method: "get",
    //data: data,
    // params: {
    //     'offset': offset
    // },
  });
};

ReportService.getProgramExport = function (params) {
  return fetch({
    url: API_BASE_URL + "/v1/admin/get-program-export",
    method: "get",
    //params: params,
  });
};

ReportService.getCareGiverExport = function (params) {
  return fetch({
    url: API_BASE_URL + "/v1/admin/get-caregiver-export",
    method: "get",
    //params: params,
  });
};

ReportService.getProgramParticipantExport = function (id) {
  return fetch({
    url: API_BASE_URL + `/v1/admin/get-program-participant-export/${id}`,
    method: "get",
    //params: params,
  });
};

ReportService.getProgramSessionExport = function (id) {
  return fetch({
    url: API_BASE_URL + `/v1/admin/get-program-session-export/${id}`,
    method: "get",
    //params: params,
  });
};

ReportService.getSessionAttendanceExport = function (id) {
  return fetch({
    url: API_BASE_URL + `/v1/admin/get-session-attendance-export/${id}`,
    method: "get",
    //params: params,
  });
};

ReportService.getSessionParticipantExport = function (id) {
  return fetch({
    url: API_BASE_URL + `/v1/admin/get-session-participant-export/${id}`,
    method: "get",
    //params: params,
  });
};

ReportService.getParticipantExport = function (params) {
  return fetch({
    url: API_BASE_URL + "/v1/admin/get-participants-export",
    method: "get",
    //params: params,
  });
};

ReportService.getPendingParticipantExport = function (filterBy = "All") {
  const queryString = `?filterBy=${encodeURIComponent(filterBy)}`;
  return fetch({
    url:
      API_BASE_URL + "/v1/admin/get-pending-participants-export" + queryString,
    method: "get",
  });
};

ReportService.getGroupParticipantExport = function (id) {
  return fetch({
    url: API_BASE_URL + `/v1/admin/get-group-participants-export/${id}`,
    method: "get",
    //params: params,
  });
};

ReportService.getGroupleaderParticipantExport = function (id) {
  return fetch({
    url: API_BASE_URL + `/v1/admin/get-groupleader-participant-export/${id}`,
    method: "get",
    //params: params,
  });
};

ReportService.getCaregiverParticipantExport = function (id) {
  return fetch({
    url: API_BASE_URL + `/v1/admin/get-caregiver-participants-export/${id}`,
    method: "get",
    //params: params,
  });
};

export default ReportService;
